import { forwardRef } from 'react';

import { IconProps } from '.';

export const SidebarExpandIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 1024 1024" ref={ref} {...props} {...{ className }}>
      <path
        d="M305.647 411.153c-14.996-14.996-14.996-39.31 0-54.306s39.31-14.996 54.306 0l128 128c14.996 14.996 14.996 39.308 0 54.304l-128 128c-14.996 14.996-39.31 14.996-54.306 0s-14.996-39.306 0-54.303l100.847-100.849-100.847-100.847z"
        fill="currentColor"
      />
      <path
        d="M793.6 153.6h-563.2c-70.692 0-128 57.308-128 128v460.8c0 70.692 57.308 128 128 128h563.2c70.692 0 128-57.308 128-128v-460.8c0-70.692-57.308-128-128-128zM793.6 230.4c28.278 0 51.2 22.923 51.2 51.2v460.8c0 28.278-22.922 51.2-51.2 51.2h-128v-563.2h128zM230.4 230.4h358.4v563.2h-358.4c-28.277 0-51.2-22.922-51.2-51.2v-460.8c0-28.277 22.923-51.2 51.2-51.2z"
        fill="currentColor"
      />
    </svg>
  );
});

export default SidebarExpandIcon;
